import React from 'react';
import ReactModal from 'react-modal';
import './CSS/ConfirmModal.css'; 
import { ReactComponent as Importante} from '../Components/Assets/importante.svg';


ReactModal.setAppElement('#root');

const ConfirmModal = ({ isOpen, onConfirm, onCancel, message }) => {
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onCancel}
            overlayClassName="overlay"
            className="modal-content"
        >
            <Importante className="icon"/>
            <p>{message}</p>
            <div className="modal-buttons">
                <button className="btn cancel" onClick={onCancel}>Cancelar</button>
                <button className="btn confirm" onClick={onConfirm}>Remover</button>
            </div>
        </ReactModal>
    );
};

export default ConfirmModal;
